<template>
  <div id="app">
    <b-navbar
      toggleable="lg"
      type="light"
      variant="light"
      fixed="top"
      :class="{ scrolled: isScrolled }"
      id="navbar"
    >
      <b-navbar-brand to="/">
        <img src="./assets/logo_new.svg" alt="Logo Nacinarki" id="logo" />
        <span class="logo-text">
          <b>NACINARKI</b>.COM.PL
        </span>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto nav-links">
          <b-navbar-nav>
            <b-nav-item to="/" exact>O firmie</b-nav-item>
            <b-nav-item to="/produkty">Produkty</b-nav-item>
            <b-nav-item to="/instrukcja">Instrukcja</b-nav-item>
            <b-nav-item to="/kontakt">Kontakt</b-nav-item>
          </b-navbar-nav>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>

    <div class="nav-spacer"></div>

    <div>
      <b-jumbotron>
        <div class="blue-box">
          <h3 v-show="currentPath=='/'">Urządzenia dla poligrafii</h3>
          <h3 v-show="currentPath=='/produkty'">Produkty</h3>
          <h3 v-show="currentPath=='/instrukcja'">Instrukcja obsługi</h3>
          <h3 v-show="currentPath=='/kontakt'">Kontakt</h3>

          <span class="d-none d-md-block">
            zadzwoń
            <b>601 403 460</b>
          </span>
          <div class="d-none d-md-block">
            <b-button
              v-show="currentPath == '/kontakt'"
              size="lg"
              variant="outline-light"
              to="/"
            >Strona główna</b-button>
            <b-button
              v-show="currentPath != '/kontakt'"
              size="lg"
              variant="outline-light"
              to="/kontakt#mapka"
            >Mapa dojazdu</b-button>
          </div>
              
          <div class="d-block d-md-none text-nowrap">
            <b-button
              size="lg"
              variant="outline-light"
              href="tel:0048601403460"
            >
              <b>601 403 460</b>
            </b-button>
          </div>
        </div>
      </b-jumbotron>
    </div>
    <!-- transition doesn't work good with wow.js -->
    <!-- <transition appear enter-active-class="animated fadeIn"> -->
      <router-view />
    <!-- </transition> -->

    <Footer />

    <transition name="chevron-anim">
      <div class="scroll-to-top" v-show="showScrollTop" @click="scrollToTop">
        <font-awesome-icon icon="chevron-up" />
      </div>
    </transition>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
import { log } from 'util'
import { setTimeout } from 'timers'

export default {
  components: {
    Footer
  },
  data() {
    return {
      isScrolled: false,
      showScrollTop: false,
      currentPath: ''
    }
  },
  methods: {
    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  },
  created() {
    this.currentPath = this.$router.currentRoute.path

    // check scrollbar position, then property this.isScrolled is true and body gets class .scrolled // show scroll to top
    let _navbar = document.querySelector('#navbar')

    let isScrolledDown = () => {
      let position = document.documentElement.scrollTop
      position > 150 ? (this.isScrolled = true) : (this.isScrolled = false)
      position > 500
        ? (this.showScrollTop = true)
        : (this.showScrollTop = false)
      if (this.isScrolled) document.body.classList.add('scrolled')
      else document.body.classList.remove('scrolled')
    }

    isScrolledDown()
    window.addEventListener('scroll', isScrolledDown)
    window.addEventListener('resize', isScrolledDown)
  },
  watch: {
    $route(to, from) {
      this.currentPath = this.$router.currentRoute.path
    }
  },
  mounted() {
    //rotating logo
    let gearLogo = document.getElementById('logo')
    window.addEventListener('scroll', function() {
      gearLogo.style.transform = 'rotate(' + window.pageYOffset / 2 + 'deg)'
    })
    // lose focus
    document.addEventListener('click', function(e) { if(document.activeElement.toString() == '[object HTMLButtonElement]'){ document.activeElement.blur() } })
  }
}
</script>


<style lang="scss">
@import url('https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.2/animate.min.css');
@import url('https://fonts.googleapis.com/css?family=Montserrat:300,700,900|Roboto:300,400,500,700&display=swap&subset=latin-ext');

$border-width: 2px;

$border-radius: 0;
$border-radius-lg: 0;
$border-radius-sm: 0;

$primary: #eb7227;
$secondary: #48c4ff;
$light: white;
$card-border-width: 0;
$btn-box-shadow: 0;
$btn-font-weight: 300;
$btn-padding-x-lg: 30px;
$btn-padding-x: 30px;
@import 'node_modules/bootstrap/scss/bootstrap';
@import 'node_modules/bootstrap-vue/src/index.scss';

$navbar-height: 100px;
$navbar-height-scrolled: 60px !important;

body {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  position: relative;
  top: 0px;
  margin-bottom: 0px;
  transition: all 300ms ease;
}

.nav-spacer {
  height: $navbar-height;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    height: $navbar-height-scrolled;
  }
}
.navbar {
  padding: 0 !important;
  height: $navbar-height;
  transition: all 300ms ease;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    height: $navbar-height-scrolled;
  }
}
.navbar-light .navbar-brand {
  background: transparent !important;
  height: $navbar-height;
  padding: 0;
  transition: all 300ms ease;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    height: $navbar-height-scrolled;
  }
}
.navbar-light .navbar-nav .nav-link {
  text-transform: uppercase;
  font-size: 23px;
  height: $navbar-height;
  display: flex;
  align-items: center;
  font-weight: 300;
  padding: 0 40px;
  transition: all 300ms ease;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    height: $navbar-height-scrolled;
    font-size: 16px;
  }
  @media (min-width: map-get($grid-breakpoints, 'lg')) and (max-width: 1250px) {
    font-size: 18px;
    padding: 0 20px;
  }
}
.nav-link.router-link-exact-active,
.nav-link.router-link-active,
.navbar-light .navbar-nav .nav-link:hover {
  color: white !important;
  background: $primary;
}
.navbar-brand img {
  // width: 116px;
  margin-left: 18px;
  width: 100px;
  transition: all 300ms ease;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    // width: 70px;
    width: 60px;
  }
  @media (max-width: map-get($grid-breakpoints, 'sm') - 1) {
    margin-left: 0px;
  }
}
.logo-text {
  color: #ff6802 !important;
  font-size: 35px;
  font-weight: 300;
  position: relative;
  top: 9px;
  transition: all 300ms ease;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    font-size: 24px;
    top: 4px;
  }
}
.logo-text b {
  font-weight: 900;
}
ul.navbar-nav,
.navbar-nav.ml-auto.nav-links {
  transition: all 300ms ease;

  background: none !important;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    background: white !important;
  }
}
body.scrolled {
  top: -40px;
  margin-bottom: -40px;
}
.scrolled {
  &.bg-light {
    background-color: #000 !important;
  }
  &.navbar {
    height: $navbar-height-scrolled;
  }
  &.navbar-light .navbar-brand {
    height: $navbar-height-scrolled;
  }
  .navbar-brand img {
    // width: 70px;
    width: 60px;
  }
  &.navbar-light .navbar-nav .nav-link {
    font-size: 16px;
    height: $navbar-height-scrolled;
    color: white;
  }
  .logo-text {
    font-size: 24px;
    top: 4px;
  }
  .navbar-nav {
    @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
      background: black !important;
    }
  }
  .navbar-toggler {
    border-color: rgba(255, 255, 255, 0.692) !important;
  }

  .navbar-toggler-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='rgba(255,255,255, 0.9)' stroke-width='2' stroke-linecap='round' stroke-miterlimit='10' d='M4 8h24M4 16h24M4 24h24'/%3E%3C/svg%3E") !important;
  }
}
.navbar-light .navbar-toggler {
  margin-right: 15px !important;
  position: absolute;
  right: 0;
}
.jumbotron {
  text-align: center;
  background: url('./assets/jumbo.jpg');
  height: 470px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-position-x: center;
  background-position-y: center;
  background-size: 150%;
  @media (max-width: map-get( $grid-breakpoints, 'md' ) - 1) {
    height: 350px;
  }
}
#real-blue-box {
  position: absolute;
  top: 500px;
  left: 50%;
  width: 200px;
  height: 200px;
}
.blue-box {
  background-color: rgba($secondary, 0.75);
  font-family: Montserrat, Arial, Helvetica, sans-serif;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 100px 20px;
  font-size: 33px;
  transition: all 300ms ease;
  overflow-x: hidden;
  h3 {
    font-size: 35px;
    font-weight: bold;
    margin: 0;
    animation: chevron-fade-in 1.3s;
  }
  b {
    font-size: 39px;
    font-weight: bold;
  }
  .btn {
    margin: 15px 0;
    text-transform: uppercase;
    font-size: 17px;
    animation: chevron-fade-in 1.3s;
    &:hover {
      color: $secondary;
    }
  }
  @media (max-width: map-get($grid-breakpoints, 'md') - 1) {
    padding: 40px 50px 20px;
    b {
      font-size: 29px;
    }
    .btn {
      margin-top: 30px;
    }
  }
}
.scroll-to-top {
  // box-shadow: 0px 0px 10px 0px #3a3a3a;
  position: fixed;
  right: 50px;
  bottom: 50px;
  width: 60px;
  height: 60px;
  font-size: 35px;
  background: rgb(26, 26, 26);
  border-radius: 3px;
  border: 3px solid #929292;
  color: #909090;
  z-index: 998;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 300ms ease;
  cursor: pointer;
  padding-bottom: 3px;
  opacity: 0.8;
  &:hover {
    background: rgb(43, 43, 43);
    border-color: rgb(209, 209, 209);
    color: rgb(201, 201, 201);
  }
}

.chevron-anim-enter-active {
  animation: chevron-fade-in 0.3s;
}
.chevron-anim-leave-active {
  animation: chevron-fade-in 0.3s reverse;
}
@keyframes chevron-fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.duration {
  animation-duration: 0.3s;
}
.delay {
  animation-delay: 0.3s;
}
.spacer {
  height: 50px;
  @media (max-width: map-get($grid-breakpoints, 'lg') - 1) {
    height: 30px;
  }
}
.modal-open, .modal-open .modal{
  padding-right:0 !important;
  overflow:initial;
}
</style>
